import { IconButton } from "@mui/material";
import React from "react";
import { AppContext } from "../../../../store/genesys.context";
import FA__ChevronLeft from "../../../../assets/icons/chevron-left-regular-full.svg";
import SvgIcon from "../../icons/svgIcon/svgIcon";

const BackToWelcomPageButton = (): React.JSX.Element => {
  const {
    openChat,
    handleOpenChat,
    skipWelcomePage,
  }: {
    openChat: boolean;
    handleOpenChat: (state: boolean) => void;
    skipWelcomePage: boolean;
  } = React.useContext(AppContext);

  const handleClick = (): void => handleOpenChat(false);

  return (
    <React.Fragment>
      {/* Nothing to go back to once the welcome page is skipped. */}
      {openChat && !skipWelcomePage && (
        <IconButton
          aria-label="zurück zur Startseite"
          onClick={handleClick}
          sx={{
            color: (theme) => theme.palette.widgetStyles.navbar.chevronColor,
            "&:hover": {
              backgroundColor: (theme) =>
                theme.palette.widgetStyles.navbar.chevronHoverColor,
              cursor: "pointer",
            },
            // A11Y FIX: visible keyboard focus indicator, matching the other
            // controls. Uses the chevron color so it contrasts on the dark navbar.
            "&:focus-visible": {
              outline: (theme) =>
                `2px solid ${theme.palette.widgetStyles.navbar.chevronColor}`,
              outlineOffset: "2px",
            },
          }}
        >
          <SvgIcon
            icon={FA__ChevronLeft}
            color={(theme) => theme.palette.widgetStyles.navbar.chevronColor}
          />
        </IconButton>
      )}
    </React.Fragment>
  );
};

export default BackToWelcomPageButton;
